module.exports = __webpack_public_path__ + "static/media/1615343032690.688a7615.jpg";